import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41b408de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title label" }
const _hoisted_2 = { class: "message-area" }
const _hoisted_3 = { class: "start-date" }
const _hoisted_4 = { class: "icon-text" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Início em:", -1))
const _hoisted_7 = {
  key: 0,
  class: "end-date"
}
const _hoisted_8 = { class: "icon-text" }
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fim em:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["body", { 'is-active': !_ctx.alarm.endedAt, alarm: _ctx.alarm.type == 'alarm' }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["icon-area", { alarm: _ctx.alarm.type == 'alarm'} ])
    }, [
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-triangle-exclamation" })
    ], 2),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.alarm.name), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.alarm.message), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-clock" })
        ]),
        _hoisted_6
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.startTime), 1)
    ]),
    (_ctx.endTime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-regular fa-clock" })
            ]),
            _hoisted_10
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.endTime), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}